import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DocumentCategoryService as ComponentService } from '../document-category.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import {
	DocumentCategory as objectPayload,
	DocumentCategoryAddPayload as objectAddPayload,
	DocumentCategoryEditPayload as objectEditPayload,
	DocumentCategoryForm as objectForm
} from '../document-category.interface';

@Component({
	selector: 'app-edit-document-category',
	templateUrl: './edit-document-category.component.html',
	styleUrls: ['./edit-document-category.component.scss']
})
export class EditDocumentCategoryComponent {
	componentTitle = 'Actualizare Categorie Document';

	errorTitle: string = environment.config.customNotifications.headers.error;
	errorIcon: string = environment.config.customNotifications.icons.error;
	errorType: string = environment.config.customNotifications.icons.error;
	helper = helper;

	token!: string;
	isLoading = false;
	form: FormGroup = new FormGroup({
		name: new FormControl(this.data.name, [Validators.required]),
		slug: new FormControl(this.data.slug, [Validators.required]),
	});

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		private dialogRef: MatDialogRef<EditDocumentCategoryComponent>,
		private componentService: ComponentService,
		private notificationService: NotificationService,
		private authService: AuthService
	) {
		this.processToken();
	}

	closeDialog() {
		this.dialogRef?.close({
			success: false,
		});
	}

	processToken() {
		const tokenObj = this.authService.returnTokenUser();
		tokenObj.then((token) => {
			this.token = token;
			this.componentService.setToken(token);
		});
	}

	submitForm() {
		this.isLoading = true;

		const { name, slug } = this.form
			.value as objectPayload;
		const updateObj: objectEditPayload = {
			id: this.data.id,
			name,
			slug
		};

		this.componentService
			.update(updateObj)
			.pipe(finalize(() => (this.isLoading = false)))
			.subscribe({
				next: () => {
					this.dialogRef.close({ success: true });
				},
				error: (err) => {
					let msg;
					try {
						// try to catch the message from server
						msg = err.error.errors.message[0];
					} catch (error) {
						// controll output message
						msg = helper.dialogConfig.generalMessages.error;
					}
					this.notificationService.warningSwal(
						helper.dialogConfig.headers.errorAtentie,
						msg,
						this.errorIcon
					);
				},
			});
	}

	onHttpError(res: any) {
		if (res.errors && res.errors.message && res.errors.message.length > 0) {
			res.errors.message.forEach((msg: string) => {
				this.notificationService.warningSwal(
					this.errorTitle,
					msg,
					this.errorIcon
				);
			});
		} else {
			let msg;
			try {
				// try to catch the message from server
				msg = res.error.errors.message[0];
			} catch (error) {
				// controll output message
				msg = helper.dialogConfig.generalMessages.error;
			}
			this.notificationService.warningSwal(
				this.errorTitle,
				msg,
				this.errorIcon
			);
		}
	}


}
